import { TABLE_PAGE_SIZE_KEY } from '@/common/constants';
import { RootState } from '@/store/store';
import {
  createSelector,
  createSlice,
  Draft,
  PayloadAction,
} from '@reduxjs/toolkit';

type TablePageSizeState = {
  current: { [tableKey: string]: number } | null;
};

const initialState: TablePageSizeState = {
  current:
    JSON.parse(localStorage.getItem(TABLE_PAGE_SIZE_KEY) as string) ?? null,
};

const tablPageSizeSlice = createSlice({
  name: 'table-page-size',
  initialState,
  reducers: {
    setTablePageSize: (
      state: Draft<TablePageSizeState>,
      action: PayloadAction<{ [tableKey: string]: number }>,
    ) => {
      state.current = { ...state.current, ...action.payload };

      localStorage.setItem(TABLE_PAGE_SIZE_KEY, JSON.stringify(state.current));
    },
  },
});

export const selectTablePageSize = createSelector(
  (state: RootState) => state.tablePageSize,
  (tablePageSizeState) => tablePageSizeState.current,
);

export const { setTablePageSize } = tablPageSizeSlice.actions;

export default tablPageSizeSlice.reducer;
